import React from "react";
import OfficeCheckForm from "../components/OfficeCheckForm";

const OfficeCheck = () => {
    return (
        <>
            <section className="flex justify-center items-center w-full h-screen bg-gray-100">
                <OfficeCheckForm />
            </section>
        </>
    );
};

export default OfficeCheck;
